module.exports = __webpack_public_path__ + "img/068b048.svg";